import { Checkbox, DatePicker, Select, Space } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import type { LeadFilters } from "../hooks/useLeadFilters";
import { useLeadFormOptions } from "../hooks/useLeads";

const { RangePicker } = DatePicker;

interface Props {
	filters: LeadFilters;
	onChange: (next: LeadFilters) => void;
}

/**
 * Ro'yxat va xarita AYNAN shu panelni ko'rsatadi — ikki nusxa bo'lsa
 * ular jimgina ajralib ketardi (spec §8.4).
 *
 * ⚠️ Sana `RangePicker` dan UTC ISO ga aylantiriladi (`Z` bilan) —
 * `LeadListQuerySchema` ofsetli qiymatni RAD ETADI.
 */
export function LeadFilterBar({ filters, onChange }: Props) {
	const { t } = useTranslation("leads");
	const { data: forms = [] } = useLeadFormOptions();

	const range: [Dayjs, Dayjs] | null =
		filters.from && filters.to ? [dayjs(filters.from), dayjs(filters.to)] : null;

	return (
		<Space wrap className="mb-4">
			<RangePicker
				value={range}
				onChange={(value) =>
					onChange({
						...filters,
						from: value?.[0] ? value[0].startOf("day").toISOString() : undefined,
						to: value?.[1] ? value[1].endOf("day").toISOString() : undefined,
					})
				}
			/>
			<Select
				allowClear
				placeholder={t("filters.formPlaceholder")}
				style={{ minWidth: 200 }}
				value={filters.formId}
				options={forms.map((form) => ({ value: form.id, label: form.name }))}
				onChange={(formId?: string) => onChange({ ...filters, formId })}
			/>
			<Checkbox
				checked={filters.outsideZone === true}
				onChange={(e) => onChange({ ...filters, outsideZone: e.target.checked ? true : undefined })}
			>
				{t("filters.outsideZone")}
			</Checkbox>
			<Checkbox
				checked={filters.flagged === true}
				onChange={(e) => onChange({ ...filters, flagged: e.target.checked ? true : undefined })}
			>
				{t("filters.flagged")}
			</Checkbox>
		</Space>
	);
}
